
Vue.component("vue_showposter", {
  props: {
    img_url: String,
    is_show_tips: Boolean
  },
  template: `<div class="vue_showimg">
  <div class="vue_showimg_mask">
		<div class="poster-close">
		  <img @click="clickClose" src='https://assets.rurushishi.com/yq-rs-h5/encourage_box_close.png'/>
		</div>
    <div class="vue_showimg_content">
      <div class="b1">
        <img :src="img_url"/>
      </div>
      <div class="poster-tips" v-if="is_show_tips">亲，长按海报 保存图片或发送给朋友！</div>
    </div>
		<div class="changePoster" @click="handleChange">
			<div class="changeText">更换海报背景</div>
		</div>
  </div>
</div>`,
  data() {
    return {
    }
  },
  methods: {
    clickClose: function () {
      this.$emit("close");
    },
		handleChange: function() {
			this.$emit("change_img")
		}
  },
  created() {
  }
})
